import SettingTypes from '@/utils/setting-types'
import { platformType } from '@/utils/decor-types'

export default {
  name: 'books',
  label: {
    title: '电子书',
    icon: require('@/assets/icon-component-label_Books.svg'),
    limit: -1,
    show: () => Number(platformType) === 1
  },
  sort: 100,
  data: {
    books: [],
    show_type: 'default'
  },
  settings: {
    books: {
      type: SettingTypes.custom,
      component_name: 'BooksSelector'
    },
    show_type: {
      type: SettingTypes.radio_button,
      label: '显示模式',
      column: true,
      options: [
        { label: '普通模式', value: 'default' },
        { label: '模式一', value: 'mode1' },
        { label: '模式二', value: 'mode2' },
        { label: '模式三', value: 'mode3' }
      ]
    },
    title: {
      type: SettingTypes.input,
      label: '标题文字',
      show: data => data.show_type !== 'default'
    },
    subtitle: {
      type: SettingTypes.input,
      label: '副标题文字',
      show: data => data.show_type !== 'default'
    }
  }
}
